(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-story-carousel]';

    const init = (root) => {
      if (!root || root.dataset.storyCarouselReady === 'true') return;

      const track = root.querySelector('[data-story-track]');
      if (!track) return;

      root.dataset.storyCarouselReady = 'true';

      const prevButton = root.querySelector('[data-story-prev]');
      const nextButton = root.querySelector('[data-story-next]');
      const autoplayDelay = (parseFloat(root.dataset.autoplay) || 0) * 1000;

      let autoplayTimer = null;
      let scrollFrame = null;

      const stepSize = () => {
        const card = track.firstElementChild;
        if (!card) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };

      const maxScroll = () => track.scrollWidth - track.clientWidth;

      const update = () => {
        const max = maxScroll();
        root.dataset.scrollable = max > 2 ? 'true' : 'false';
        if (prevButton) prevButton.disabled = track.scrollLeft <= 2;
        if (nextButton) nextButton.disabled = track.scrollLeft >= max - 2;
      };

      const scrollToPosition = (left) => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
      };

      const stopAutoplay = () => {
        if (!autoplayTimer) return;
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      const startAutoplay = () => {
        if (!autoplayDelay || autoplayTimer) return;
        autoplayTimer = setInterval(() => {
          const max = maxScroll();
          if (max <= 2) return;
          const next = track.scrollLeft >= max - 2 ? 0 : track.scrollLeft + stepSize();
          scrollToPosition(next);
        }, autoplayDelay);
      };

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          stopAutoplay();
          scrollToPosition(track.scrollLeft - stepSize());
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          stopAutoplay();
          scrollToPosition(track.scrollLeft + stepSize());
        });
      }

      track.addEventListener(
        'scroll',
        () => {
          if (scrollFrame) return;
          scrollFrame = requestAnimationFrame(() => {
            scrollFrame = null;
            update();
          });
        },
        { passive: true }
      );

      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(update).observe(track);
      } else {
        window.addEventListener('resize', update);
      }

      if (autoplayDelay) {
        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);
        root.addEventListener('focusin', stopAutoplay);
        track.addEventListener('touchstart', stopAutoplay, { passive: true });
        startAutoplay();
      }

      root.storyCarouselStop = stopAutoplay;
      update();
    };

    const initAll = (scope) => {
      const root = scope || document;
      if (root.matches && root.matches(SELECTOR)) init(root);
      if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));

    document.addEventListener('shopify:section:unload', (event) => {
      const target = event.target;
      if (!target || !target.querySelectorAll) return;
      target.querySelectorAll(SELECTOR).forEach((root) => {
        if (typeof root.storyCarouselStop === 'function') root.storyCarouselStop();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-testimonials"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      const container = document.querySelector(
        '[data-whatsapp-testimonials][data-api-url="https://api.thewordofmouth.in/api/whatsapp-images/vaarnika"]'
      );
      if (!container) return;

      const apiUrl = container.getAttribute('data-api-url');
      if (!apiUrl) return;

      const dummyTestimonials = [
        {
          title: 'Feels like second skin',
          text:
            'Soft, breathable fabric that stays easy all day.',
        },
        {
          title: 'Comfort with quiet luxury',
          text:
            'Easy to move in, with handpaint that feels refined.',
        },
        {
          title: 'Authenticity in every fold',
          text:
            'Natural handpaint variations make it feel one-of-a-kind.',
        },
        {
          title: 'Light, airy and elegant',
          text:
            'Lightweight yet modest, it instantly elevates outfits.',
        },
      ];

      const buildCard = (imageUrl, testimonial, index) => {
        const wrapper = document.createElement('article');
        wrapper.className = 'whatsapp-testimonial-card';

        wrapper.innerHTML = `
          <div class="whatsapp-testimonial-image-wrapper">
            <img
              src="${imageUrl}"
              loading="lazy"
              alt="Vaarnika customer in handpainted look"
              class="whatsapp-testimonial-image"
            />
          </div>
        `;

        return wrapper;
      };

      const initCarousel = (track) => {
        if (!track) return;
        const wrapper = track.closest('[data-whatsapp-testimonials-wrapper]');
        if (!wrapper) return;

        const cards = track.querySelectorAll('.whatsapp-testimonial-card');
        if (!cards.length) return;

        const prevBtn = wrapper.querySelector('[data-whatsapp-prev]');
        const nextBtn = wrapper.querySelector('[data-whatsapp-next]');
        if (!prevBtn || !nextBtn) return;

        let currentIndex = 0;
        let autoTimer = null;

        const scrollToIndex = (index) => {
          const safeIndex = (index + cards.length) % cards.length;
          const card = cards[safeIndex];
          if (!card) return;
          const left = card.offsetLeft;
          track.scrollTo({ left, behavior: 'smooth' });
          currentIndex = safeIndex;
        };

        const startAuto = () => {
          if (autoTimer) return;
          autoTimer = setInterval(() => {
            scrollToIndex(currentIndex + 1);
          }, 2000);
        };

        const stopAuto = () => {
          if (!autoTimer) return;
          clearInterval(autoTimer);
          autoTimer = null;
        };

        prevBtn.addEventListener('click', () => {
          stopAuto();
          scrollToIndex(currentIndex - 1);
        });

        nextBtn.addEventListener('click', () => {
          stopAuto();
          scrollToIndex(currentIndex + 1);
        });

        wrapper.addEventListener('mouseenter', stopAuto);
        wrapper.addEventListener('mouseleave', startAuto);

        startAuto();
      };

      const renderTestimonials = (urls) => {
        container.innerHTML = '';
        if (!urls || !urls.length) {
          container.innerHTML =
            '<p class="whatsapp-testimonials-empty">Real stories are on their way. Check back soon.</p>';
          return;
        }

        urls.slice(0, 5).forEach((url, index) => {
          if (!url) return;
          const card = buildCard(url, dummyTestimonials[index], index);
          container.appendChild(card);
        });

        initCarousel(container);
      };

      fetch(apiUrl, { credentials: 'omit' })
        .then((response) => {
          if (!response.ok) throw new Error('Network error');
          return response.json();
        })
        .then((data) => {
          if (!data || !Array.isArray(data.s3_urls)) {
            throw new Error('Unexpected API response');
          }
          renderTestimonials(data.s3_urls);
        })
        .catch(() => {
          renderTestimonials([]);
        });
    });
  
  } catch(e) { console.error(e); }
})();
})();
